if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.previousButton = this.querySelector('[data-media-previous]');
        this.nextButton = this.querySelector('[data-media-next]');
        this.currentCounter = this.querySelector('[data-media-current]');
        this.totalCounter = this.querySelector('[data-media-total]');
        this.content = this.querySelector('.product-media-modal__content');
        this.dialog = this.querySelector('.product-media-modal__dialog');
        this.zoomControls = this.querySelector('[data-media-zoom-controls]');
        this.zoomInButton = this.querySelector('[data-media-zoom-in]');
        this.zoomOutButton = this.querySelector('[data-media-zoom-out]');
        this.touchStartX = null;

        this.previousButton?.addEventListener('click', () => this.changeMedia(-1));
        this.nextButton?.addEventListener('click', () => this.changeMedia(1));
        this.zoomInButton?.addEventListener('click', () => this.setZoom(true));
        this.zoomOutButton?.addEventListener('click', () => this.setZoom(false));

        [
          this.previousButton,
          this.nextButton,
          this.zoomInButton,
          this.zoomOutButton,
          this.querySelector('[id^="ModalClose-"]'),
        ].forEach((control) => {
          control?.addEventListener('pointerup', (event) => event.stopPropagation());
        });

        this.dialog?.addEventListener('pointerup', (event) => {
          event.stopPropagation();
          if (event.pointerType === 'mouse' && (event.target === this.dialog || event.target === this.content)) {
            this.hide();
          }
        });

        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;
          if (event.key === 'ArrowLeft') this.changeMedia(-1);
          if (event.key === 'ArrowRight') this.changeMedia(1);
        });

        this.content?.addEventListener('touchstart', (event) => {
          this.touchStartX = event.changedTouches[0]?.clientX ?? null;
        }, { passive: true });

        this.content?.addEventListener('touchend', (event) => {
          if (this.touchStartX === null) return;
          const distance = (event.changedTouches[0]?.clientX ?? this.touchStartX) - this.touchStartX;
          this.touchStartX = null;
          if (Math.abs(distance) < 50) return;
          this.changeMedia(distance > 0 ? -1 : 1);
        }, { passive: true });
      }

      hide() {
        this.resetZoom();
        super.hide();
      }

      show(opener) {
        this.resetZoom();
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.mediaItems = Array.from(this.content?.children || []).filter((element) => element.hasAttribute('data-media-id'));
        const requestedMediaId = this.openedBy.getAttribute('data-media-id');
        this.activeIndex = this.mediaItems.findIndex((element) => element.getAttribute('data-media-id') === requestedMediaId);
        if (this.activeIndex < 0) this.activeIndex = 0;
        this.renderActiveMedia();
      }

      changeMedia(direction) {
        if (!this.mediaItems?.length || this.mediaItems.length < 2) return;
        window.pauseAllMedia();
        this.resetZoom();
        this.activeIndex = (this.activeIndex + direction + this.mediaItems.length) % this.mediaItems.length;
        this.renderActiveMedia();
      }

      setZoom(zoomed) {
        const activeMedia = this.mediaItems?.[this.activeIndex];
        if (!(activeMedia instanceof HTMLImageElement)) return;

        activeMedia.classList.toggle('is-zoomed', zoomed);
        this.zoomInButton.disabled = zoomed;
        this.zoomOutButton.disabled = !zoomed;
      }

      resetZoom() {
        this.mediaItems?.forEach((element) => element.classList.remove('is-zoomed'));
        if (this.zoomInButton) this.zoomInButton.disabled = false;
        if (this.zoomOutButton) this.zoomOutButton.disabled = true;
      }

      renderActiveMedia() {
        const activeMedia = this.mediaItems[this.activeIndex];
        if (!activeMedia) return;

        this.mediaItems.forEach((element, index) => {
          element.classList.toggle('active', index === this.activeIndex);
          element.setAttribute('aria-hidden', index === this.activeIndex ? 'false' : 'true');
        });

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        this.currentCounter.textContent = this.activeIndex + 1;
        this.totalCounter.textContent = this.mediaItems.length;
        this.toggleAttribute('data-single-media', this.mediaItems.length < 2);
        if (this.zoomControls) this.zoomControls.hidden = !(activeMedia instanceof HTMLImageElement);

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
